var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "regex-picker" }, [
    _c("div", { staticClass: "search-panel" }, [
      _c("input", {
        attrs: {
          maxlength: "128",
          placeholder: _vm.$t("chatbotv2.typeSearchValue"),
          type: "text",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "entity-list" }, [
      _c(
        "div",
        { staticClass: "entity-select" },
        [
          _c("div", { staticClass: "text-uppercase caption" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.regexTemplates"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.regexList, function (entity) {
            return _c(
              "div",
              {
                staticClass: "picker-item",
                class: { active: _vm.defaultSelected === entity.regex },
                on: {
                  click: function ($event) {
                    return _vm.pick(entity.regex)
                  },
                },
              },
              [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(entity.description) + " "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(entity.example) +
                      "\n                "
                  ),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }